import { WORKOUT_EXERCISE_KEY } from '../../../model'
import saveReduxAction from '../../../../redux/actions/save'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'
import { WORKOUT_EXERCISES_ENDPOINT } from '../../constants/endpoint'
import getByIdWorkoutExerciseSelector from '../../selectors/get-by-id'
import getCurrentIdWorkoutExerciseSelect from '../../selectors/get-id'
import getByIdWorkoutSectionSelector from '../../../../workout-section/redux/selectors/get-by-id'
import canEditByIdWorkoutSelector from '../../../../workout/redux/selectors/can-edit-by-id'
import getByIdWorkoutSelector from '../../../../workout/redux/selectors/get-by-id'
import getCurrentOrStartedWorkoutSelect from '../../../../workout/redux/selectors/get-current-or-started'
import { logUtil } from 'packages/src'
import { interpolateStringUtil } from '../../../../../utils/string/interpolate'

function saveWorkoutExerciseAction (idParam) {
  return (dispatch, getState) => {
    const id = idParam || getCurrentIdWorkoutExerciseSelect(getState())
    const workoutExercise = getByIdWorkoutExerciseSelector(id)(getState())
    if (!workoutExercise) {
      return
    }

    const workoutId = getValueReduxUtil(
      workoutExercise,
      WORKOUT_EXERCISE_KEY.WORKOUT_ID
    )
    if (!workoutId) {
      logUtil('').debug('[noop] no workoutId')
      return
    }
    const workout = getByIdWorkoutSelector(workoutId)(getState()) ||
      (
        getCurrentOrStartedWorkoutSelect(getState())
      )
    const workoutSection = getByIdWorkoutSectionSelector(getValueReduxUtil(
      workoutExercise,
      WORKOUT_EXERCISE_KEY.WORKOUT_SECTION_ID
    ))(getState())

    if (workout && isNewReduxUtil(workout)) {
      logUtil('').debug('[noop] new workout: ', getIdReduxUtil(workout))
      return
    }

    if (workoutSection && isNewReduxUtil(workoutSection)) {
      logUtil('').debug(
        '[noop] new workoutSection: ',
        getIdReduxUtil(workoutSection)
      )
      return
    }

    if (!canEditByIdWorkoutSelector(getIdReduxUtil(workout))) {
      logUtil('').debug('[noop] can’t edit workout: ', getIdReduxUtil(workout))
      return
    }

    let endpoint
    if (isNewReduxUtil(workoutExercise)) {
      endpoint = WORKOUT_EXERCISES_ENDPOINT.ROOT
    } else {
      endpoint = interpolateStringUtil(WORKOUT_EXERCISES_ENDPOINT.BY_ID, {
        id: getIdReduxUtil(workoutExercise)
      })
    }

    return dispatch(saveReduxAction({
      type: WORKOUT_EXERCISES_ACTION.SAVE,
      payload: {
        endpoint: endpoint,
        path: getPathReduxUtil(workoutExercise)
      }
    }))
  }
}

export { saveWorkoutExerciseAction }
